/* PCのメガメニューを、余白のクリックで閉じる。
 *
 * Dawn標準（details-disclosure.js）は focusout でしか閉じないため、
 * パネル内の左右の余白のようにフォーカスを持たない場所をクリックしても閉じなかった。
 *
 * 閉じる条件は2つ：
 *   ① パネルの余白（page-width の外側の左右、または列と列のすき間）をクリックした
 *   ② メニューの外側（ページ本文など）をクリックした
 * メニューの項目やリンクをクリックしたときは、当然そのまま遷移させる。
 */
(function () {
  function closeDetails(details) {
    const holder = details.closest('header-menu');
    if (holder && typeof holder.close === 'function') {
      holder.close();
      return;
    }
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (event) {
    const openDetails = document.querySelectorAll('.cc-nav details[open]');
    if (!openDetails.length) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const insideNav = target.closest('.cc-nav');
    const panel = target.closest('.cc-mega-panel');
    // パネル自身、または page-width のコンテナを直接クリック＝余白
    const isPanelMargin =
      panel && (target === panel || target.classList.contains('cc-mega'));

    if (!insideNav || isPanelMargin) {
      openDetails.forEach(closeDetails);
    }
  });
})();
